import list from './list'
import edit from './edit'
import track from './track'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state,
    edit.state,
    track.state,
  ),
  mutations: Object.assign(
    list.mutations,
    edit.mutations,
    track.mutations,
  )
}



// WEBPACK FOOTER //
// ./src/store/flights/index.js